<template>
	<div>{{ timerOutput }}</div>
</template>
<script>
export default {
	props: ['seconds'],
	data() {
		return {
			timerOutput: null,
			timeDifference: this.seconds,
			interval: null,
		}
	},
	methods: {
		startTimer: function () {

			const seconds = this.timeDifference;
			const hours = Math.floor(seconds / 3600)
			const minutes = Math.floor((seconds % 3600) / 60)
			const remainingSeconds = seconds % 60

			const hourString = hours > 0 ? hours.toString().padStart(2, '0') : '00'
			const minuteString = minutes > 0 ? minutes.toString().padStart(2, '0') : '00'
			const secondString = remainingSeconds > 0 ? remainingSeconds.toString().padStart(2, '0') : '00'

			this.timerOutput = `${hourString}:${minuteString}:${secondString}`
		},
	},
	mounted() {
		this.interval = setInterval(() => {
			this.timeDifference--;

			if (this.timeDifference > 0) {
				this.startTimer()
			} else {
				clearInterval(this.interval);
				this.$emit('expired');
			}
		}, 1000);
	}
}
</script>
